import React, { Component } from "react";
import classnames from "classnames";
import { observer } from "mobx-react";

import { IUser } from "@formant/core/model/IUser";
import { Uuid } from "@formant/core/model/Uuid";

import { userStore } from "../../stores";
import * as styles from "./Avatar.scss";

export interface IAvatarProps {
    user?: IUser;
    initials?: string;
    userId?: Uuid;
    size: "tiny" | "small" | "medium" | "large";
    light?: true;
    className?: string;
    tooltip?: string;
}

@observer
export class Avatar extends Component<IAvatarProps> {
    public render() {
        const { userId, light, className, size, tooltip, initials } =
            this.props;

        const user = this.props.user
            ? this.props.user
            : userId
              ? userStore.get(userId) || undefined
              : undefined;
        const email = user?.email;
        const firstName = user?.firstName || "";
        const lastName = user?.lastName || "";

        if (!user) {
            return false;
        }

        return (
            <div
                className={classnames(
                    styles.avatar,
                    light && styles.light,
                    className,
                    styles[size],
                )}
            >
                <div className={styles.circle}>
                    <div
                        className={styles.initials}
                        title={tooltip || `${firstName} ${lastName} - ${email}`}
                    >
                        {(firstName[0] || initials || "") + (lastName[0] || "")}
                    </div>
                </div>
            </div>
        );
    }
}
